import { cloneDeep } from '@bingads-webui-universal/primitive-utilities';
import { BaseSchemaProcessor } from './base-schema-processor';

export class TagSchemaProcessor extends BaseSchemaProcessor {
  updateEntitySchemaForFeatures(entitySchema) {
    const {
      IsCustomerHierarchyEnabled,
      IsSharedLibraryPhase1Enabled,
    } = this.Permissions;
    const isOwnerFilterable = IsCustomerHierarchyEnabled && IsSharedLibraryPhase1Enabled;
    const updatedSchema = cloneDeep(entitySchema);

    if (!isOwnerFilterable) {
      delete updatedSchema.properties.OwnerName;
      delete updatedSchema.properties.OwnerNumber;
    }

    return updatedSchema;
  }
}
